import type { ICellRendererParams } from 'ag-grid-community';
import classNames from 'classnames';
import { FC } from 'react';
import { QuoteType } from 'state/quotes/infos/infos.model';

export const QuoteModeCellRenderer: FC<ICellRendererParams<unknown, QuoteType>> = ({ value }) => {
  return (
    <span
      className={classNames('badge rounded-pill', {
        'badge-flat-success': value === 'Indicative',
        'badge-flat-info': value === 'Executable',
      })}
    >
      <span className="ms-1 fw-normal text-primary">{value}</span>
    </span>
  );
};
